import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_Accounts_may_be_restricted_for_ELL,
  TXTWCL_To_find_out_moreX_visit_our_Xa_ELL
} from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <>
    <Translation {...TXTWCL_Accounts_may_be_restricted_for_ELL} />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.HelpRestrictedAccount}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_To_find_out_moreX_visit_our_Xa_ELL}
    />
  </>
);

export default HelpSectionContent;
